import React, { useCallback } from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { Snippets } from '../../../Publish/Snippets';
import { SnippetCardViewProps } from '../../../Publish/Snippets/SnippetCard/SnippetCard.view';
import { CustomEditor } from '../../../../models/slate-editor';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import { deserializeText } from '../helpers/serializer';

export type SnippetPickerViewProps = {
  //
  editor: CustomEditor;
  onCloseSnippet: VoidFunction;
  onToggleCreate: VoidFunction;
};

export const SnippetPickerView = (props: SnippetPickerViewProps): JSX.Element => {
  const { onCloseSnippet, editor } = props;

  const onAddToPostClick: SnippetCardViewProps['onAddToPostClick'] = useCallback(
    (shouldAddDots: boolean, content: string) => {
      const focused = ReactEditor.isFocused(editor);
      if (!focused) ReactEditor.focus(editor);
      if (shouldAddDots) content = `.\n.\n.\n.\n.\n${content}`;
      const nodes = deserializeText(content, [], null, false);
      Transforms.insertNodes(editor, nodes);
      onCloseSnippet();
    },
    [editor, onCloseSnippet]
  );

  return (
    <Modal
      onClose={onCloseSnippet}
      title={'Add Snippet to Post'}
      showCloseIcon
      closeOnClickOutside={false}
      size={'large'}>
      <Snippets onAddToPostClick={onAddToPostClick} context={'MODAL'} />
    </Modal>
  );
};
